export const Types = {
  REQUEST: '@refreshToken/REQUEST',
  FAILURE: '@refreshToken/FAILURE',
  SET: '@refreshToken/SET',
};

interface IPayloadProps {
  hash: string | null;
  grantType: string;
  type: string;
}

export interface IPayload {
  payload: IPayloadProps;
}

export function refreshTokenRequest(payload: IPayloadProps) {
  return {
    type: Types.REQUEST,
    payload,
  };
}

export function refreshTokenError(error: Object) {
  return {
    type: Types.FAILURE,
    error,
  };
}

function setOnStorage(hash: string): void {
  sessionStorage.setItem('refresh_token', hash);
}

export function setRefreshToken(refreshToken: string) {
  setOnStorage(refreshToken);

  return {
    type: Types.SET,
    hash: refreshToken,
  };
}
